import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hpgmw3yct2: FaireBrandEntity = {
  token: "b_hpgmw3yct2",
  type: "brand",
  name: "SIIX Collection",
  avatarUrl:
    "https://cdn.faire.com/fastly/f80089891ac1201201f437ef2ae946d4b22b1bb6b24a616d43bc9846a32cb16b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6584ddfb48fe4a17d06ee4103f0be652300d00c18ae1dff7e98ca2236c738fae.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f80089891ac1201201f437ef2ae946d4b22b1bb6b24a616d43bc9846a32cb16b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6584ddfb48fe4a17d06ee4103f0be652300d00c18ae1dff7e98ca2236c738fae.jpeg",
  location: "Tempe, AZ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 98,
  isTopShop: true,
  isInsider: true,
  description:
    "A new (& affordable) Organic collection for baby/toddler/preschooler. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:03.043Z",
    importedBy: "entity-db-cli",
  },
};
